// extracted by css-extract-rspack-plugin
export default {"rootProjects":"EDdX6tT9HAojwthN","rootProjectsList":"H1lRoxyIeU5Tcc2a"};